<div class="sign-up-container">
  <div class="heading-page">Influencer Program</div>
  <form class="sign-up-form" novalidate [formGroup]="newUser">
    <div *ngIf="isLogin">
      <input required formControlName="fullName"
             name="fullName"
             type="text"
             class="form-control"
             placeholder="{{'register.fields.full_name' | translate}}" />

      <input required
             formControlName="email"
             name="email"
             type="email"
             class="form-control"
             placeholder="{{'register.fields.email' | translate}}"
             email />

      <input required
             formControlName="password"
             name="password"
             type="password"
             class="form-control password-field"
             placeholder="{{'register.fields.password' | translate}}" />

      <input required
             formControlName="confirmPassword"
             name="confirmPassword"
             type="password"
             class="form-control confirm-password-field"
             placeholder="{{'register.fields.confirm_password' | translate}}" />

      <div class="term">
        <div class="d-flex flex-column align-items-center">
          <div class="d-flex">
            <div class="term-input"><achoo-checkbox></achoo-checkbox></div>
            <div class="term-input-note">Agree to our <span (click)="showConfirmBox()">Terms of Services</span></div>
          </div>
        </div>
      </div>

      <button class="btn btn-default"
              type="submit">{{'sign_up.btn' | translate}}</button>
    </div>


    <div *ngIf="!isLogin">
      <div class="confirm-note">We have sent an email with a confirmation code.
        In order to complete the sign-up process, please
        type in your confirmation code below.</div>
      <input required
             name="confirmCode"
             type="text"
             class="form-control"
             placeholder="{{'register.fields.confirm_code' | translate}}" />

      <button class="btn btn-default"
              type="submit">{{'confirm.btn' | translate}}</button>
    </div>

    <p class="register-new-account-link d-flex flex-row">
      <span class="already-login">Click <span (click)="showLoginBox()">here</span> if you are ready to login</span>
    </p>

  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-auth/influencer-sign-up/influencer-sign-up.component.html